export default __webpack_public_path__ + "static/media/stagnation.24f85177.png";